import React from 'react'

import * as Styled from './styled'
import type { VirtualProductThumbnailProps } from './types'

export const VirtualProductThumbnail = ({
  symbol = '$',
  size = 'medium',
}: VirtualProductThumbnailProps) => (
  <Styled.Container size={size} aria-label="Virtual Product Thumbnail">
    {symbol}
  </Styled.Container>
)
